/**
 * Share Hook
 * React Query hook for sharing content to users via DM
 */

import type { ApiError } from "@shared-types/api.types"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { AxiosError } from "axios"
import { toast } from "sonner"
import type { ShareRequest, ShareResponse } from "@/services/share.service"
import { sendShareMessage } from "@/services/share.service"

export function useSendShare() {
  const queryClient = useQueryClient()

  return useMutation<ShareResponse, AxiosError<ApiError>, ShareRequest>({
    mutationFn: sendShareMessage,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ["dm-conversations"] })
      queryClient.invalidateQueries({ queryKey: ["all-conversations"] })
      toast.success(data.message)
    },
    onError: error => {
      const message = error.response?.data?.message || "Failed to share"
      toast.error(message)
    },
  })
}
